<template>
  <div>
    <FormKit
      type="hidden"
      :name="`components[${index}][component_type]`"
      :value="component.component_type"
    />

    <FormKit
      label="Titel"
      type="text"
      :name="`components[${index}][title]`"
      :value="component.title"
      @input="(value) => update('title', value)"
    />

    <FormKit
      label="Omschrijving"
      type="textarea"
      :name="`components[${index}][description]`"
      :value="component.description"
      @input="(value) => update('description', value)"
    />

    <FormKit
      label="Bedankt tekst"
      type="text"
      :name="`components[${index}][feedback]`"
      :value="component.feedback"
      @input="(value) => update('feedback', value)"
    />

  </div>
</template>

<script>
import mixin from "../mixins/component";

export default {
  name: "PageNewsletter",
  mixins: [mixin],
};
</script>